import React, {useEffect, useMemo, useRef, useState} from "react";
import Button from "../../../../../components/button/button.jsx";
import { Modal } from "../../../../../components/modal/modal.jsx";
import { useQuery } from "@tanstack/react-query";
import InputForm from "../../../../../components/input/input-form.jsx";
import { FaEraser, FaSearch } from "react-icons/fa";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const initialFilter = {
    name: "",
    vms: ""
};

const ModalSectors = ({ open, setOpen, sectors, selectedSectorIds = [], onSave }) => {
    const gridRef = useRef(null);
    const [rowData, setRowData] = useState([]);

    const columnDefs = useMemo(
        () => [
            { headerName: "ID", field: "id", width: 75 },
            { headerName: "Tipo", field: "type", width: 150 },
            { headerName: "Nome", field: "name", flex: 1 },
        ],
        []
    );

    useEffect(() => {
        setRowData(sectors);
    }, [sectors]);

    const selectCurrentSectors = () => {
        if (!gridRef.current) return;

        gridRef.current.api.deselectAll();

        gridRef.current.api.forEachNode(node => {
            if (selectedSectorIds.includes(node.data.id)) {
                node.setSelected(true);
            }
        });
    };

    useEffect(() => {
        if (!open) return;

        setTimeout(selectCurrentSectors, 0);
    }, [open, selectedSectorIds]);

    const handleSave = () => {
        const selected = gridRef.current.api.getSelectedRows();
        onSave(selected.map(s => s.id));
        setOpen(false);
    };

    return (
        <Modal open={open} setOpen={setOpen} title="Setores" className="w-1/3">
            <Modal.Body className="flex flex-col gap-3">
                <div className="h-[400px] w-full">
                    <AgGridReact
                        ref={gridRef}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        rowSelection={{
                            mode: "multiRow",
                            enableSelectionWithoutKeys: true,
                            enableClickSelection: true,
                        }}
                        suppressCellFocus
                        animateRows={false}
                        gridOptions={{ localeText: aggridUtils.localization() }}
                        theme={aggridUtils.generalTheme()}
                        onGridReady={selectCurrentSectors}
                    />
                </div>
            </Modal.Body>

            <Modal.Footer className="p-2">
                <Button target="primary" onClick={handleSave}>
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalSectors;